<template>
  <SettingsLayout>
    <div
      v-if="showSave"
      class="
        bg-teal-100
        border-t-4 border-teal-500
        rounded-b
        text-teal-900
        px-4
        py-3
        shadow-md
        absolute
        top-0
        right-0
      "
      role="alert"
    >
      <div class="flex">
        <div>
          <!-- <p class="font-bold">Our privacy policy has changed</p> -->
          <p class="text-sm">Änderungen wurden gespeichert.</p>
        </div>
      </div>
    </div>

    <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink class="mr-3" href="/" type="close">Schließen</HeaderLink>
      <HeaderButton @click="showSave = true">Speichern</HeaderButton>
    </template>
    <Heading title="Rollenverwaltung" />

    <p class="max-w-2xl text-sm text-oteoText mb-9">
      Bitte weisen Sie den Nutzer/innen die Rolle zu, mit denen die
      entsprechenden Berechtigungen für oteo hinterlegt sind. Bei Bedarf können
      Sie neue Rollen hinzufügen und die Berechtigungen anpassen.
    </p>

    <Button
      v-if="canEdit"
      href="/einstellungen/rollenverwaltung/erstellen"
      class="mb-9"
    >
      Neue Rolle hinzufügen
    </Button>

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-scroll max-h-[450px]">
            <table class="min-w-full">
              <thead class="bg-white border-b">
                <tr class="sticky top-0 bg-white">
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Rolle
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Einstellungen
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Termine
                  </th>

                  <!-- <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Aktion
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(role, index) in roles.data"
                  :key="role.id"
                  class="border-b"
                  :class="{ 'bg-gray-100': index % 2 === 0 }"
                >
                  <TD class="align-baseline">
                    <div class="">
                      {{ role.name }}
                    </div>
                  </TD>
                  <TD>
                    <div class="flex items-center mb-4">
                      <input
                        :disabled="!canEdit || role.name === 'Administrator'"
                        @change="check(role.id, 'settings', 'read', $event)"
                        v-model="role.can.settings.read"
                        type="checkbox"
                      />
                      <Label class="ml-4 mb-0">Lesen</Label>
                    </div>
                    <div class="flex items-center mb-4">
                      <input
                        :disabled="!canEdit || role.name === 'Administrator'"
                        @change="check(role.id, 'settings', 'edit', $event)"
                        v-model="role.can.settings.edit"
                        type="checkbox"
                      />
                      <Label class="ml-4 mb-0">Bearbeiten</Label>
                    </div>
                    <div class="flex items-center">
                      <input
                        :disabled="!canEdit || role.name === 'Administrator'"
                        @change="check(role.id, 'settings', 'delete', $event)"
                        v-model="role.can.settings.delete"
                        type="checkbox"
                      />
                      <Label class="ml-4 mb-0">Löschen</Label>
                    </div>
                  </TD>
                  <TD>
                    <div class="flex items-center mb-4">
                      <input
                        :disabled="!canEdit || role.name === 'Administrator'"
                        @change="check(role.id, 'appointments', 'read', $event)"
                        v-model="role.can.appointments.read"
                        type="checkbox"
                      />
                      <Label class="ml-4 mb-0">Lesen</Label>
                    </div>
                    <div class="flex items-center mb-4">
                      <input
                        :disabled="!canEdit || role.name === 'Administrator'"
                        @change="check(role.id, 'appointments', 'edit', $event)"
                        v-model="role.can.appointments.edit"
                        type="checkbox"
                      />
                      <Label class="ml-4 mb-0">Bearbeiten</Label>
                    </div>
                    <div class="flex items-center">
                      <input
                        :disabled="!canEdit || role.name === 'Administrator'"
                        @change="
                          check(role.id, 'appointments', 'delete', $event)
                        "
                        v-model="role.can.appointments.delete"
                        type="checkbox"
                      />
                      <Label class="ml-4 mb-0">Löschen</Label>
                    </div>
                  </TD>
                  <!-- <TD> auswertungen </TD> -->
                  <!-- <TD class="align-baseline">
                    <div v-if="canEdit" class="flex items-center text-oteo-300">
                      <div class="cursor-pointer" @click="deactivate(role.id)">
                        <i class="las la-times"></i>
                        deaktivieren
                      </div>
                    </div>
                  </TD> -->
                </tr>

                <tr>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

<script setup>
import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import Button from "@/Components/Button.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";

import { Head, useForm, Link } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import axios from "axios";
import { ref } from "vue";

const page_name = "Rollenverwaltung";
const canEdit = Inertia.page.props.auth.can["edit settings"];

/** AJAX Request to toggle permissions
 * @param {number} role_id - The id of the role.
 * @param {string} domain - The domain of the permission.
 * @param {string} permission - The name of the permission.
 * @param {event} value - The event of the input.
 * */

function check(role_id, domain, permission, value) {
  let checked = value.target.checked;
  if (canEdit) {
    axios.put("/roles/" + role_id, {
      domain,
      permission,
      value: checked,
    });
  }
}

const showSave = ref(false);

defineProps({
  roles: Object,
});

</script>
